class CustomPrescription {

	constructor() {
		this.stepsContainer = document.querySelector(".prescription-form-container .steps");
		if (!this.stepsContainer) {
			return;
		}
		this.steps = document.querySelectorAll(".prescription-form-container .step");
		this.stepsContainer = document.querySelector(".steps");
		this.progress = document.querySelector(".progress-container .progress-inner");
		this.feetChoose = document.querySelector(".input-radio#feet");
		this.handsChoose = document.querySelector(".input-radio#hands");
		this.prescriptionProducts = document.querySelector(".prescription-products");
		this.backToStepsButton = document.querySelector("#backToStepsButton");
		this.feetQuestion1 = document.querySelector(`[data-step-type="feet"][data-step-number="1"]`);
		this.feetQuestion2 = document.querySelector(`[data-step-type="feet"][data-step-number="2"]`);
		this.feetQuestion3 = document.querySelector(`[data-step-type="feet"][data-step-number="3"]`);
		this.handsQuestion1 = document.querySelector(`[data-step-type="hands"][data-step-number="1"]`);
		this.handsQuestion2 = document.querySelector(`[data-step-type="hands"][data-step-number="2"]`);
		this.handsQuestion3 = document.querySelector(`[data-step-type="hands"][data-step-number="3"]`);
		this.handsQuestion4 = document.querySelector(`[data-step-type="hands"][data-step-number="4"]`);
		this.products = document.querySelectorAll(`[data-product-id]`);
		this.crmDescription = document.querySelector(`[name="lead|description"]`);

		this.buildNavs();
		this.setContainerSize();
		// this.buildUnloadEvent();
		this.backToSteps();
		this.observeCRMSuccess();

		resizeCallbacks.push(this);
	}

	displayProducts() {
		document.querySelector(".step.active").classList.remove("active");
		this.stepsContainer.classList.remove("active");
		this.prescriptionProducts.classList.add("active");
		ScrollTrigger.refresh();
		this.formSubmitted = true;
		this.computeCorrespondingProducts();
	}

	getAnswers(page) {
		const answers = [];
		page.querySelectorAll(".selected[data-slug]").forEach(answer => {
			answers.push(answer.dataset.slug);
		});
		return answers;
	}

	computeCorrespondingProducts() {
		const config = [
			{
				answers: this.getAnswers(this.feetQuestion1),
				productField: "feet1"
			},
			{
				answers: this.getAnswers(this.feetQuestion2),
				productField: "feet2"
			},
			{
				answers: this.getAnswers(this.feetQuestion3),
				productField: "feet3"
			},
			{
				answers: this.getAnswers(this.handsQuestion1),
				productField: "hands1"
			},
			{
				answers: this.getAnswers(this.handsQuestion2),
				productField: "hands2"
			},
			{
				answers: this.getAnswers(this.handsQuestion3),
				productField: "hands3"
			},
			{
				answers: this.getAnswers(this.handsQuestion4),
				productField: "hands4"
			},
		];

		const results = [];
		window.customPrescriptionData.forEach(product => {
			let productMatch = true;
			config.forEach(question => {
				if (question.answers.length) {
					question.answers.forEach(answer => {
						if (!product[question.productField].includes(answer)) {
							productMatch = false;
						}
					});
				}
			});
			if (productMatch) {
				results.push(product);
			}
		});

		if (results.length === this.products.length) {
			results.length = 0;
		}

		console.log(`${results.length} product${results.length > 1 ? "s" : ""} found`, results);

		this.products.forEach(product => {
			product.classList.add("d-none");
		});

		const crmResult = [];
		results.forEach(product => {
			document.querySelector(`[data-product-id="${product.id}"]`).classList.remove("d-none");
			crmResult.push(product.reference);
		});
		this.crmDescription.value = crmResult.join(";");

		ScrollTrigger.refresh();
	}

	backToSteps() {
		this.backToStepsButton.addEventListener("click", () => {
			this.stepsContainer.classList.add("active");
			this.prescriptionProducts.classList.remove("active");
			ScrollTrigger.refresh();
			window.scrollTo(0, 0);
			if (this.currentType === "feet") {
				document.querySelector(`[data-step-type="feet"][data-step-number="3"]`).classList.add("active");
			} else {
				document.querySelector(`[data-step-type="hands"][data-step-number="4"]`).classList.add("active");
			}
		});
	}

	buildNavs() {
		this.buildPreviousNavs();
		this.buildNextNavs();
	}

	buildNextNavs() {
		document.querySelectorAll(".prescription-form-container [data-nav=next]").forEach(nav => {
			const page = nav.closest("[data-step-type]");
			const requiredMessage = nav.querySelector(".required-message");
			nav.addEventListener("click", () => {
				if (!page.querySelector(".selected")) {
					gsap.to(requiredMessage, {
						opacity: 1,
						duration: 0.3,
						onComplete: () => {
							gsap.to(requiredMessage, {
								opacity: 0,
								delay: 1.5
							});
						}
					});
					return;
				}
				if (page.dataset.stepType === "main") {
					if (this.feetChoose.classList.contains("selected")) {
						this.goNext(page, "feet", "1");
						this.setProgress(25);
					} else {
						this.goNext(page, "hands", "1");
						this.setProgress(20);
					}
				} else if (page.dataset.stepType === "feet") {
					this.currentType = "feet";
					switch (page.dataset.stepNumber) {
						case "1":
							this.goNext(page, "feet", "2");
							this.setProgress(50);
							break;
						case "2":
							this.goNext(page, "feet", "3");
							this.setProgress(75);
							break;
						case "3":
							if (this.formSubmitted) {
								this.displayProducts();
							} else {
								this.goNext(page, "feet", "4");
								this.setProgress(100);
							}
							break;
					}
				} else if (page.dataset.stepType === "hands") {
					this.currentType = "hands";
					switch (page.dataset.stepNumber) {
						case "1":
							this.goNext(page, "hands", "2");
							this.setProgress(40);
							break;
						case "2":
							this.goNext(page, "hands", "3");
							this.setProgress(60);
							break;
						case "3":
							this.goNext(page, "hands", "4");
							this.setProgress(80);
							break;
						case "4":
							if (this.formSubmitted) {
								this.displayProducts();
							} else {
								this.goNext(page, "hands", "5");
								this.setProgress(100);
							}
							break;
					}
				}
			});
		});
	}

	buildPreviousNavs() {
		document.querySelectorAll(".prescription-form-container [data-nav=previous]").forEach(nav => {
			const page = nav.closest("[data-step-type]");
			nav.addEventListener("click", () => {
				if (page.dataset.stepType === "feet") {
					switch (page.dataset.stepNumber) {
						case "1":
							this.goPrevious(page, "main", "0");
							this.setProgress(0);
							break;
						case "2":
							this.goPrevious(page, "feet", "1");
							this.setProgress(25);
							break;
						case "3":
							this.goPrevious(page, "feet", "2");
							this.setProgress(50);
							break;
						case "4":
							this.goPrevious(page, "feet", "3");
							this.setProgress(75);
							break;
					}
				} else if (page.dataset.stepType === "hands") {
					switch (page.dataset.stepNumber) {
						case "1":
							this.goPrevious(page, "main", "0");
							this.setProgress(0);
							break;
						case "2":
							this.goPrevious(page, "hands", "1");
							this.setProgress(20);
							break;
						case "3":
							this.goPrevious(page, "hands", "2");
							this.setProgress(40);
							break;
						case "4":
							this.goPrevious(page, "hands", "3");
							this.setProgress(60);
							break;
						case "5":
							this.goPrevious(page, "hands", "4");
							this.setProgress(80);
							break;
					}
				}
			});
		});
	}

	goNext(current, type, number) {
		this.computeCorrespondingProducts();
		current.classList.add("previous");
		this.steps.forEach(step => {
			if (step.dataset.stepType === type && step.dataset.stepNumber === number) {
				step.classList.add("active");
			} else {
				step.classList.remove("active");
			}
		});
	}

	goPrevious(current, type, number) {
		current.classList.add("previous");
		this.steps.forEach(step => {
			if (step.dataset.stepType === type && step.dataset.stepNumber === number) {
				current.classList.remove("previous");
				step.classList.add("active");
			} else {
				step.classList.remove("active");
			}
		});
	}

	setContainerSize() {
		let minHeight = 0;
		this.steps.forEach(step => {
			if (step.clientHeight > minHeight) {
				minHeight = step.clientHeight;
			}
		});
		this.stepsContainer.style.minHeight = `${minHeight}px`;
		ScrollTrigger.refresh();
	}

	buildUnloadEvent() {
		window.onbeforeunload = function () {
			return document.querySelector("[data-unload-message]").dataset.unloadMessage;
		};
		document.querySelector("#submitInput").addEventListener("click", () => {
			this.removeUnloadEvent();
		});
	}

	removeUnloadEvent() {
		window.onbeforeunload = null;
	}

	setProgress(value) {
		this.progress.style.width = `calc(${value}% - 4px)`;
	}

	observeCRMSuccess() {
		const crmForm = document.querySelector("#sb_form");
		const observer = new MutationObserver(mutationsList => {
			for (let mutation of mutationsList) {
				if (mutation.type === 'childList') {
					this.displayProducts();
				}
			}
		});
		observer.observe(crmForm, {childList: true, subtree: true});
	}

	resize() {
		this.setContainerSize();
	}
}
